// extracted by mini-css-extract-plugin
export default {"dictionary":"dictionary_dictionary__8oTtQ"};